import "./style.css";

import Prefab from "./Experience/Prefab.js";

const experience = new Prefab(document.querySelector(".webgl"));
